// This list acts as the master for logic located elsewhere in the Master Site. Updates to this list will automatically be applied.
export const permissions = {
    'Adjudication': {
        MASTER: 'read/write',
        ADMIN: 'none',
        CSR: 'read',
        "CSR II": 'read',
        "CSR III": 'read/write',
        ADJUDICATION: 'read/write',
        "ADJUDICATION II": 'read/write',
        SALES: 'none',
        "SALES II": 'none',
        "SALES LEAD": 'none',
        "PRODUCT TEAM": 'none',
        "PRODUCT TEAM II": 'read',
        GSR: 'none',
        "GSR II": 'none',
        "GSR III": 'read',
        "GSR LEAD": 'read',
        "INSURANCE LEAD": 'read/write',
        ACCOUNTING: 'read',
        "ACCOUNTING II": 'read',
        UNDERWRITING: 'none',
        "UNDERWRITING II": 'none',
        "UNDERWRITING LEAD": 'none'
    },
    'Administration': {
        MASTER: 'read/write',
        ADMIN: 'none',
        CSR: 'read',
        "CSR II": 'read/write',
        "CSR III": 'read/write',
        ADJUDICATION: 'none',
        "ADJUDICATION II": 'none',
        SALES: 'read',
        "SALES II": 'read',
        "SALES LEAD": 'read',
        "PRODUCT TEAM": 'none',
        "PRODUCT TEAM II": 'none',
        "GSR II": 'read',
        "GSR III": 'read',
        "GSR LEAD": 'read',
        "INSURANCE LEAD": 'read/write',
        "UNDERWRITING LEAD": 'read/write'
    },
    'Advisors': {
        MASTER: 'read/write',
        ADMIN: 'read',
        CSR: 'read',
        "CSR II": 'read',
        "CSR III": 'read/write',
        ADJUDICATION: 'read',
        "ADJUDICATION II": 'read',
        SALES: 'read/write',
        "SALES II": 'read/write',
        "SALES LEAD": 'read/write',
        "PRODUCT TEAM": 'read',
        "PRODUCT TEAM II": 'read',
        GSR: 'read',
        "GSR II": 'read/write',
        "GSR III": 'read/write',
        "GSR LEAD": 'read/write',
        "INSURANCE LEAD": 'read/write',
        ACCOUNTING: 'read/write',
        "ACCOUNTING II": 'read/write',
        UNDERWRITING: 'read',
        "UNDERWRITING II": 'read/write',
        "UNDERWRITING LEAD": 'read/write'
    },
    'Accounts': {
        MASTER: 'read/write',
        ADMIN: 'read',
        CSR: 'read',
        "CSR II": 'read',
        "CSR III": 'read',
        ADJUDICATION: 'read',
        "ADJUDICATION II": 'read',
        SALES: 'read',
        "SALES II": 'read',
        "SALES LEAD": 'read/write',
        "PRODUCT TEAM": 'read',
        "PRODUCT TEAM II": 'read',
        GSR: 'read',
        "GSR II": 'read',
        "GSR III": 'read/write',
        "GSR LEAD": 'read/write',
        "INSURANCE LEAD": 'read/write',
        ACCOUNTING: 'read',
        "ACCOUNTING II": 'read',
        UNDERWRITING: 'read',
        "UNDERWRITING II": 'read',
        "UNDERWRITING LEAD": 'read'
    },
    'Quotes': {
        MASTER: 'read/write',
        ADMIN: 'none',
        CSR: 'none',
        "CSR II": 'none',
        "CSR III": 'none',
        ADJUDICATION: 'none',
        "ADJUDICATION II": 'none',
        SALES: 'read/write',
        "SALES II": 'read/write',
        "SALES LEAD": 'read/write',
        "PRODUCT TEAM": 'read',
        "PRODUCT TEAM II": 'read',
        "GSR III": 'read',
        "GSR LEAD": 'read',
        "INSURANCE LEAD": 'read',
        "UNDERWRITING II": 'read/write',
        "UNDERWRITING LEAD": 'read/write'
    },
    'Quotes for Review': {
        MASTER: 'read/write',
        ADMIN: 'none',
        CSR: 'none',
        "CSR II": 'none',
        "CSR III": 'none',
        ADJUDICATION: 'none',
        "ADJUDICATION II": 'none',
        SALES: 'read',
        "SALES II": 'read',
        "SALES LEAD": 'read',
        "PRODUCT TEAM": 'read',
        "PRODUCT TEAM II": 'read',
        GSR: 'read',
        "GSR II": 'read',
        "GSR III": 'read',
        "GSR LEAD": 'read',
        "INSURANCE LEAD": 'read',
        "UNDERWRITING II": 'read/write',
        "UNDERWRITING LEAD": 'read/write'
    },
    'Members': {
        MASTER: 'read/write',
        ADMIN: 'read',
        CSR: 'read',
        "CSR II": 'read',
        "CSR III": 'read',
        ADJUDICATION: 'read',
        "ADJUDICATION II": 'read',
        SALES: 'read',
        "SALES II": 'read',
        "SALES LEAD": 'read',
        "PRODUCT TEAM": 'read',
        "PRODUCT TEAM II": 'read',
        GSR: 'read',
        "GSR II": 'read',
        "GSR III": 'read/write',
        "GSR LEAD": 'read/write',
        "INSURANCE LEAD": 'read/write',
        ACCOUNTING: 'read',
        "ACCOUNTING II": 'read',
        UNDERWRITING: 'read',
        "UNDERWRITING II": 'read',
        "UNDERWRITING LEAD": 'read'
    },
    'Reports': {
        MASTER: 'read/write',
        ADMIN: 'read',
        CSR: 'read',
        "CSR II": 'read',
        "CSR III": 'read',
        ADJUDICATION: 'none',
        "ADJUDICATION II": 'read',
        SALES: 'read',
        "SALES II": 'read',
        "SALES LEAD": 'read',
        "PRODUCT TEAM": 'read',
        "PRODUCT TEAM II": 'read',
        GSR: 'read',
        "GSR II": 'read',
        "GSR III": 'read',
        "GSR LEAD": 'read',
        "INSURANCE LEAD": 'read',
        ACCOUNTING: 'read',
        "ACCOUNTING II": 'read',
        UNDERWRITING: 'read',
        "UNDERWRITING II": 'read',
        "UNDERWRITING LEAD": 'read'
    },
    'Data Uploads': {
        MASTER: 'read/write',
        ADMIN: 'read/write',
        CSR: 'none',
        "CSR II": 'none',
        "CSR III": 'read/write',
        ADJUDICATION: 'none',
        "ADJUDICATION II": 'read/write',
        SALES: 'none',
        "PRODUCT TEAM": 'none',
        "PRODUCT TEAM II": 'read',
        ACCOUNTING: 'read/write',
        "ACCOUNTING II": 'read/write',
        UNDERWRITING: 'read/write',
        "UNDERWRITING II": 'read/write',
        "UNDERWRITING LEAD": 'read/write',
        "INSURANCE LEAD": 'read/write'
    },
    'Data Downloads': {
        MASTER: 'read/write',
        ADMIN: 'read/write',
        CSR: 'read',
        "CSR II": 'read',
        "CSR III": 'read/write',
        ADJUDICATION: 'none',
        "ADJUDICATION II": 'read/write',
        SALES: 'none',
        "PRODUCT TEAM": 'none',
        "PRODUCT TEAM II": 'read',
        "UNDERWRITING II": 'read/write',
        "UNDERWRITING LEAD": 'read/write'
    },
    'Claims': {
        MASTER: 'read/write',
        ADMIN: 'none',
        CSR: 'read',
        "CSR II": 'read',
        "CSR III": 'read',
        ADJUDICATION: 'read',
        "ADJUDICATION II": 'read',
        SALES: 'none',
        "PRODUCT TEAM": 'none',
        "PRODUCT TEAM II": 'read',
        "GSR III": 'read',
        "GSR LEAD": 'read',
        "INSURANCE LEAD": 'read/write',
        "ACCOUNTING II": 'read'
    },
    'Adjudicate Claim': {
        MASTER: 'read/write',
        ADMIN: 'none',
        CSR: 'read',
        "CSR II": 'read',
        "CSR III": 'read/write',
        ADJUDICATION: 'read/write',
        "ADJUDICATION II": 'read/write',
        SALES: 'none',
        "PRODUCT TEAM": 'none',
        "PRODUCT TEAM II": 'read',
        "GSR III": 'read',
        "GSR LEAD": 'read',
        "INSURANCE LEAD": 'read/write',
        "ACCOUNTING II": 'read'
    },
    'Reset Adjudication': {
        MASTER: 'read/write',
        ADMIN: 'none',
        CSR: 'none',
        "CSR II": 'none',
        "CSR III": 'read/write',
        ADJUDICATION: 'none',
        "ADJUDICATION II": 'read/write',
        SALES: 'none',
        "PRODUCT TEAM": 'none',
        "PRODUCT TEAM II": 'none',
        "INSURANCE LEAD": 'read/write'
    },
    'Reassign Claim': {
        MASTER: 'read/write',
        ADMIN: 'none',
        CSR: 'none',
        "CSR II": 'none',
        "CSR III": 'read/write',
        ADJUDICATION: 'none',
        "ADJUDICATION II": 'read/write',
        SALES: 'none',
        "PRODUCT TEAM": 'none',
        "PRODUCT TEAM II": 'read',
        "INSURANCE LEAD": 'read/write'
    },
    'Resend Payment': {
        MASTER: 'read/write',
        ADMIN: 'none',
        CSR: 'none',
        "CSR II": 'none',
        "CSR III": 'read/write',
        ADJUDICATION: 'none',
        "ADJUDICATION II": 'none',
        "SALES": 'none',
        "PRODUCT TEAM": 'none',
        "PRODUCT TEAM II": 'read',
        "INSURANCE LEAD": 'read/write',
        ACCOUNTING: 'read/write',
        "ACCOUNTING II": 'read/write'
    },
    'Notes': {
        // profile, claim
        MASTER: 'read/write',
        ADMIN: 'read/write',
        CSR: 'read',
        "CSR II": 'read/write',
        "CSR III": 'read/write',
        ADJUDICATION: 'read/write',
        "ADJUDICATION II": 'read/write',
        "PRODUCT TEAM": 'none',
        "PRODUCT TEAM II": 'read/write',
        GSR: 'read',
        "GSR II": 'read/write',
        "GSR III": 'read/write',
        "GSR LEAD": 'read/write',
        "INSURANCE LEAD": 'read/write',
        ACCOUNTING: 'read/write',
        "ACCOUNTING II": 'read/write',
        UNDERWRITING: 'read/write',
        "UNDERWRITING II": 'read/write',
        "UNDERWRITING LEAD": 'read/write'
    },
    'Coverage': {
        // profile, claim
        MASTER: 'read/write',
        ADMIN: 'read',
        CSR: 'read',
        "CSR II": 'read',
        "CSR III": 'read',
        ADJUDICATION: 'read',
        "ADJUDICATION II": 'read',
        SALES: 'read',
        "SALES II": 'read',
        "SALES LEAD": 'read',
        "PRODUCT TEAM": 'read',
        "PRODUCT TEAM II": 'read',
        GSR: 'read',
        "GSR II": 'read',
        "GSR III": 'read/write',
        "GSR LEAD": 'read/write',
        "INSURANCE LEAD": 'read/write',
        ACCOUNTING: 'read',
        "ACCOUNTING II": 'read',
        "UNDERWRITING II": 'read',
        "UNDERWRITING LEAD": 'read' 
    },
    'Usage': {
        MASTER: 'read/write',
        ADMIN: 'none',
        CSR: 'read',
        "CSR II": 'read',
        "CSR III": 'read',
        ADJUDICATION: 'read',
        "ADJUDICATION II": 'read',
        SALES: 'none',
        "PRODUCT TEAM": 'none',
        "PRODUCT TEAM II": 'read',
        "GSR II": 'read',
        "GSR III": 'read',
        "GSR LEAD": 'read',
        "INSURANCE LEAD": 'read',
        ACCOUNTING: 'read',
        "ACCOUNTING II": 'read'
    },
    'Profile': {
        MASTER: 'read/write',
        ADMIN: 'read',
        CSR: 'read',
        "CSR II": 'read/write',
        "CSR III": 'read/write',
        ADJUDICATION: 'read',
        "ADJUDICATION II": 'read/write',
        SALES: 'read',
        "SALES II": 'read',
        "SALES LEAD": 'read',
        "PRODUCT TEAM": 'read',
        "PRODUCT TEAM II": 'read',
        GSR: 'read',
        "GSR II": 'read',
        "GSR III": 'read/write',
        "GSR LEAD": 'read/write',
        "INSURANCE LEAD": 'read/write',
        ACCOUNTING: 'read',
        "ACCOUNTING II": 'read',
        UNDERWRITING: 'read',
        "UNDERWRITING II": 'read',
        "UNDERWRITING LEAD": 'read'
    },
    'Dependents': {
        MASTER: 'read/write',
        ADMIN: 'none',
        CSR: 'read',
        "CSR II": 'read/write',
        "CSR III": 'read/write',
        ADJUDICATION: 'read',
        "ADJUDICATION II": 'read',
        SALES: 'none',
        "SALES LEAD": 'read',
        "PRODUCT TEAM": 'read',
        "PRODUCT TEAM II": 'read',
        GSR: 'read',
        "GSR II": 'read/write',
        "GSR III": 'read/write',
        "GSR LEAD": 'read/write',
        "ACCOUNTING II": 'read',
        "INSURANCE LEAD": 'read/write'
    },
    'Beneficiaries': {
        MASTER: 'read/write',
        ADMIN: 'none',
        CSR: 'read',
        "CSR II": 'read/write',
        "CSR III": 'read/write',
        ADJUDICATION: 'read',
        "ADJUDICATION II": 'read',
        SALES: 'none',
        "SALES LEAD": 'read',
        "PRODUCT TEAM": 'read',
        "PRODUCT TEAM II": 'read',
        "INSURANCE LEAD": 'read/write',
        GSR: 'read',
        "GSR II": 'read',
        "GSR III": 'read/write',
        "GSR LEAD": 'read/write',
        "ACCOUNTING II": 'read'
    },
    'Trustee': {
        MASTER: 'read/write',
        ADMIN: 'none',
        CSR: 'read',
        "CSR II": 'read/write',
        "CSR III": 'read/write',
        ADJUDICATION: 'read',
        "ADJUDICATION II": 'read',
        SALES: 'none',
        "SALES LEAD": 'read',
        "PRODUCT TEAM": 'read',
        "PRODUCT TEAM II": 'read',
        "INSURANCE LEAD": 'read',
        GSR: 'read',
        "GSR II": 'read',
        "GSR III": 'read/write',
        "GSR LEAD": 'read/write',
        "ACCOUNTING II": 'read'
    },
    'Plan Designs': {
        MASTER: 'read/write',
        ADMIN: 'read',
        CSR: 'read',
        "CSR II": 'read',
        "CSR III": 'read',
        ADJUDICATION: 'read',
        "ADJUDICATION II": 'read',
        SALES: 'read/write',
        "SALES II": 'read/write',
        "SALES LEAD": 'read/write',
        "PRODUCT TEAM": 'read',
        "PRODUCT TEAM II": 'read',
        "GSR II": 'read',
        "GSR III": 'read/write',
        "GSR LEAD": 'read/write',
        "INSURANCE LEAD": 'read/write',
        ACCOUNTING: 'read',
        "ACCOUNTING II": 'read',
        UNDERWRITING: 'read',
        "UNDERWRITING II": 'read/write',
        "UNDERWRITING LEAD": 'read/write'
    },
    'Plan Overview': {
        MASTER: 'read/write',
        ADMIN: 'read',
        CSR: 'read',
        "CSR II": 'read',
        "CSR III": 'read',
        ADJUDICATION: 'read',
        "ADJUDICATION II": 'read',
        SALES: 'read/write',
        "SALES II": 'read/write',
        "SALES LEAD": 'read/write',
        "PRODUCT TEAM": 'read',
        "PRODUCT TEAM II": 'read',
        GSR: 'read/write',
        "GSR II": 'read/write',
        "GSR III": 'read/write',
        "GSR LEAD": 'read/write',
        "INSURANCE LEAD": 'read',
        UNDERWRITING: 'read',
        "UNDERWRITING II": 'read',
        "UNDERWRITING LEAD": 'read'
    },
    'Plan Pricing': {
        MASTER: 'read/write',
        ADMIN: 'read',
        CSR: 'read',
        "CSR II": 'read',
        "CSR III": 'read',
        ADJUDICATION: 'read',
        "ADJUDICATION II": 'read',
        SALES: 'read/write',
        "SALES II": 'read/write',
        "SALES LEAD": 'read/write',
        "PRODUCT TEAM": 'read',
        "PRODUCT TEAM II": 'read',
        GSR: 'read/write',
        "GSR II": 'read/write',
        "GSR III": 'read/write',
        "GSR LEAD": 'read/write',
        "INSURANCE LEAD": 'read/write',
        ACCOUNTING: 'read',
        "ACCOUNTING II": 'read',
        UNDERWRITING: 'read',
        "UNDERWRITING II": 'read/write',
        "UNDERWRITING LEAD": 'read/write'
    },
    'Account History': {
        MASTER: 'read/write',
        ADMIN: 'none',
        CSR: 'none',
        "CSR II": 'none',
        "CSR III": 'none',
        ADJUDICATION: 'none',
        "ADJUDICATION II": 'none',
        SALES: 'read',
        "SALES II": 'read',
        "SALES LEAD": 'read',
        "PRODUCT TEAM": 'none',
        "PRODUCT TEAM II": 'read',
        GSR: 'read',
        "GSR II": 'read',
        "GSR III": 'read',
        "GSR LEAD": 'read',
        "INSURANCE LEAD": 'read',
        ACCOUNTING: 'read',
        "ACCOUNTING II": 'read'
    },
    'Account Files': {
        MASTER: 'read/write',
        ADMIN: 'read/write',
        CSR: 'read',
        "CSR II": 'read/write',
        "CSR III": 'read/write',
        ADJUDICATION: 'read/write',
        "ADJUDICATION II": 'read/write',
        SALES: 'read/write',
        "SALES II": 'read/write',
        "SALES LEAD": 'read/write',
        "PRODUCT TEAM": 'none',
        "PRODUCT TEAM II": 'read/write',
        GSR: 'read/write',
        "GSR II": 'read/write',
        "GSR III": 'read/write',
        "GSR LEAD": 'read/write',
        "INSURANCE LEAD": 'read/write',
        ACCOUNTING: 'read',
        "ACCOUNTING II": 'read/write',
        UNDERWRITING: 'read/write',
        "UNDERWRITING II": 'read/write',
        "UNDERWRITING LEAD": 'read/write'
    },
    'Advisor Files': {
        MASTER: 'read/write',
        ADMIN: 'read/write',
        CSR: 'none',
        "CSR II": 'read',
        "CSR III": 'read',
        ADJUDICATION: 'read',
        "ADJUDICATION II": 'read',
        SALES: 'read/write',
        "SALES II": 'read/write',
        "SALES LEAD": 'read/write',
        UNDERWRITING: 'read/write',
        "UNDERWRITING II": 'read/write',
        "UNDERWRITING LEAD": 'read/write',
        "PRODUCT TEAM": 'none',
        "PRODUCT TEAM II": 'read/write',
        GSR: 'read/write',
        "GSR II": 'read/write',
        "GSR III": 'read/write',
        "GSR LEAD": 'read/write'
    },
    'Member Files': {
        MASTER: 'read/write',
        ADMIN: 'none',
        CSR: 'read',
        "CSR II": 'read/write',
        "CSR III": 'read/write',
        ADJUDICATION: 'read/write',
        "ADJUDICATION II": 'read/write',
        SALES: 'none',
        "SALES II": 'read',
        "SALES LEAD": 'read',
        "PRODUCT TEAM": 'none',
        "PRODUCT TEAM II": 'read/write',
        "GSR III": 'read',
        "GSR LEAD": 'read',
        "INSURANCE LEAD": 'read/write',
        ACCOUNTING: 'read',
        "ACCOUNTING II": 'read/write',
        "UNDERWRITING LEAD": 'read'
    },
    'Review Rates': {
        MASTER: 'read/write',
        ADMIN: 'read',
        CSR: 'none',
        "CSR II": 'read',
        "CSR III": 'read',
        ADJUDICATION: 'none',
        "ADJUDICATION II": 'none',
        SALES: 'read',
        "SALES II": 'read',
        "SALES LEAD": 'read',
        "PRODUCT TEAM": 'none',
        "PRODUCT TEAM II": 'read',
        GSR: 'read',
        "GSR II": 'read',
        "GSR III": 'read',
        "GSR LEAD": 'read',
        "INSURANCE LEAD": 'read',
        ACCOUNTING: 'read',
        "ACCOUNTING II": 'read',
        UNDERWRITING: 'read',
        "UNDERWRITING II": 'read',
        "UNDERWRITING LEAD": 'read'
    },
    'Employees': {
        MASTER: 'read/write',
        ADMIN: 'read',
        CSR: 'read',
        "CSR II": 'read/write',
        "CSR III": 'read/write',
        ADJUDICATION: 'read',
        "ADJUDICATION II": 'read',
        "SALES": 'read',
        "SALES II": 'read',
        "SALES LEAD": 'read',
        "PRODUCT TEAM": 'none',
        "PRODUCT TEAM II": 'read',
        GSR: 'read',
        "GSR II": 'read/write',
        "GSR III": 'read/write',
        "GSR LEAD": 'read/write',
        "INSURANCE LEAD": 'read/write',
        ACCOUNTING: 'read',
        "ACCOUNTING II": 'read',
        UNDERWRITING: 'read',
        "UNDERWRITING II": 'read',
        "UNDERWRITING LEAD": 'read'
    },
    'Administrators': {
        MASTER: 'read/write',
        ADMIN: 'read',
        CSR: 'read',
        "CSR II": 'read/write',
        "CSR III": 'read/write',
        ADJUDICATION: 'read',
        "ADJUDICATION II": 'read',
        SALES: 'read',
        "SALES II": 'read',
        "SALES LEAD": 'read',
        "PRODUCT TEAM": 'none',
        "PRODUCT TEAM II": 'read',
        GSR: 'read',
        "GSR II": 'read/write',
        "GSR III": 'read/write',
        "GSR LEAD": 'read/write',
        "INSURANCE LEAD": 'read/write',
        ACCOUNTING: 'read',
        "ACCOUNTING II": 'read',
        UNDERWRITING: 'read',
        "UNDERWRITING II": 'read/write',
        "UNDERWRITING LEAD": 'read/write'
    },
    'Representatives': {
        MASTER: 'read/write',
        ADMIN: 'read',
        CSR: 'read',
        "CSR II": 'read',
        "CSR III": 'read',
        ADJUDICATION: 'read',
        "ADJUDICATION II": 'read',
        SALES: 'read',
        "SALES II": 'read/write',
        "SALES LEAD": 'read/write',
        "PRODUCT TEAM": 'read',
        "PRODUCT TEAM II": 'read',
        GSR: 'read',
        "GSR II": 'read',
        "GSR III": 'read/write',
        "GSR LEAD": 'read/write',
        "INSURANCE LEAD": 'read/write',
        ACCOUNTING: 'read',
        "ACCOUNTING II": 'read',
        UNDERWRITING: 'read',
        "UNDERWRITING II": 'read',
        "UNDERWRITING LEAD": 'read'
    },
    'Master Application': {
        MASTER: 'read/write',
        ADMIN: 'read',
        CSR: 'read',
        "CSR II": 'read',
        "CSR III": 'read',
        ADJUDICATION: 'none',
        "ADJUDICATION II": 'read',
        SALES: 'read/write',
        "SALES II": 'read/write',
        "SALES LEAD": 'read/write',
        "PRODUCT TEAM": 'none',
        "PRODUCT TEAM II": 'read',
        "GSR II": 'read',
        "GSR III": 'read',
        "GSR LEAD": 'read',
        "INSURANCE LEAD": 'read',
        "UNDERWRITING II": 'read',
        "UNDERWRITING LEAD": 'read'
    },
    'Member Booklets': {
        MASTER: 'read/write',
        ADMIN: 'read/write',
        CSR: 'read',
        "CSR II": 'read/write',
        "CSR III": 'read/write',
        ADJUDICATION: 'read',
        "ADJUDICATION II": 'read/write',
        SALES: 'read/write',
        "SALES II": 'read/write',
        "SALES LEAD": 'read/write',
        "PRODUCT TEAM": 'none',
        "PRODUCT TEAM II": 'read',
        GSR: 'read',
        "GSR II": 'read',
        "GSR III": 'read/write',
        "GSR LEAD": 'read/write',
        "INSURANCE LEAD": 'read/write',
        UNDERWRITING: 'read',
        "UNDERWRITING II": 'read/write',
        "UNDERWRITING LEAD": 'read/write'
    },
    'Allow Enrollments': {
        MASTER: 'read/write',
        ADMIN: 'none',
        CSR: 'none',
        "CSR II": 'none',
        "CSR III": 'read/write',
        ADJUDICATION: 'none',
        "ADJUDICATION II": 'none',
        "SALES": 'none',
        "SALES II": 'read/write',
        "SALES LEAD": 'read/write',
        "PRODUCT TEAM": 'none',
        "PRODUCT TEAM II": 'none',
        "GSR II": 'read/write',
        "GSR III": 'read/write',
        "GSR LEAD": 'read/write',
        "INSURANCE LEAD": 'read/write',
        "UNDERWRITING II": 'read/write',
        "UNDERWRITING LEAD": 'read/write'
    },
    'Invoices': {
        MASTER: 'read/write',
        ADMIN: 'read/write',
        CSR: 'read',
        "CSR II": 'read',
        "CSR III": 'read',
        ADJUDICATION: 'read',
        "ADJUDICATION II": 'read',
        SALES: 'read',
        "SALES II": 'read',
        "SALES LEAD": 'read',
        "PRODUCT TEAM": 'none',
        "PRODUCT TEAM II": 'read',
        "GSR II": 'read',
        "GSR III": 'read',
        "GSR LEAD": 'read',
        "INSURANCE LEAD": 'read/write',
        ACCOUNTING: 'read/write',
        "ACCOUNTING II": 'read/write',
        UNDERWRITING: 'read/write',
        "UNDERWRITING II": 'read/write',
        "UNDERWRITING LEAD": 'read/write'
        
    },
    'Start Revisions': {
        MASTER: 'read/write',
        ADMIN: 'none',
        CSR: 'none',
        "CSR II": 'none',
        "CSR III": 'none',
        ADJUDICATION: 'none',
        "ADJUDICATION II": 'none',
        SALES: 'none',
        "SALES II": 'read/write',
        "SALES LEAD": 'read/write',
        "PRODUCT TEAM": 'none',
        "PRODUCT TEAM II": 'read',
        "INSURANCE LEAD": 'read/write',
        "UNDERWRITING II": 'read/write',
        "UNDERWRITING LEAD": 'read/write'
    },
    'Account Settings': {
        MASTER: 'read/write',
        ADMIN: 'read/write',
        CSR: 'read',
        "CSR II": 'read/write',
        "CSR III": 'read/write',
        ADJUDICATION: 'read',
        "ADJUDICATION II": 'read',
        SALES: 'read/write',
        "SALES II": 'read/write',
        "SALES LEAD": 'read/write',
        "PRODUCT TEAM": 'none',
        "PRODUCT TEAM II": 'read',
        GSR: 'read/write',
        "GSR II": 'read/write',
        "GSR III": 'read/write',
        "GSR LEAD": 'read/write',
        "INSURANCE LEAD": 'read/write',
        UNDERWRITING: 'read/write',
        "UNDERWRITING II": 'read/write',
        "UNDERWRITING LEAD": 'read/write',
        ACCOUNTING: 'read',
        "ACCOUNTING II": 'read'
    },
    'Account Notifications': {
        MASTER: 'read/write',
        ADMIN: 'none',
        CSR: 'read',
        "CSR II": 'read',
        "CSR III": 'read',
        ADJUDICATION: 'none',
        "ADJUDICATION II": 'read',
        SALES: 'none',
        "PRODUCT TEAM": 'none',
        "PRODUCT TEAM II": 'read'
    },
    'Advisor Settings': {
        MASTER: 'read/write',
        ADMIN: 'none',
        CSR: 'read',
        "CSR II": 'read/write',
        "CSR III": 'read/write',
        ADJUDICATION: 'none',
        "ADJUDICATION II": 'read',
        SALES: 'read/write',
        "SALES II": 'read/write',
        "SALES LEAD": 'read/write',
        "PRODUCT TEAM": 'none',
        "PRODUCT TEAM II": 'read',
        GSR: 'read',
        "GSR II": 'read',
        "GSR III": 'read/write',
        "GSR LEAD": 'read/write',
        "INSURANCE LEAD": 'read/write',
        "UNDERWRITING II": 'read/write',
        "UNDERWRITING LEAD": 'read/write',
        ACCOUNTING: 'read',
        "ACCOUNTING II": 'read'
    },
    'Advisor Notifications': {
        MASTER: 'read/write',
        ADMIN: 'none',
        CSR: 'read',
        "CSR II": 'read',
        "CSR III": 'read',
        ADJUDICATION: 'none',
        "ADJUDICATION II": 'read',
        "PRODUCT TEAM": 'none',
        "PRODUCT TEAM II": 'read'
    },
    'Master Site Management': {
        MASTER: 'read/write',
        ADMIN: 'none',
        CSR: 'none',
        "CSR II": 'none',
        "CSR III": 'none',
        ADJUDICATION: 'none',
        "ADJUDICATION II": 'none',
        SALES: 'none',
        "PRODUCT TEAM": 'none',
        "PRODUCT TEAM II": 'none'
    },
    'Renewals': {
        MASTER: 'read/write',
        ADMIN: 'read/write',
        CSR: 'none',
        "CSR II": 'none',
        "CSR III": 'none',
        ADJUDICATION: 'none',
        "ADJUDICATION II": 'none',
        SALES: 'none',
        "PRODUCT TEAM": 'none',
        "PRODUCT TEAM II": 'read',
        "GSR LEAD": 'read/write',
        "INSURANCE LEAD": 'read/write',
        ACCOUNTING: 'read',
        "ACCOUNTING II": 'read',
        UNDERWRITING: 'read/write',
        "UNDERWRITING II": 'read/write',
        "UNDERWRITING LEAD": 'read/write'
    },
    'Toggle Benefits': {
        MASTER: 'read/write',
        ADMIN: 'none',
        CSR: 'none',
        "CSR II": 'none',
        "CSR III": 'read/write',
        ADJUDICATION: 'none',
        "ADJUDICATION II": 'read/write',
        SALES: 'none',
        "PRODUCT TEAM": 'none',
        "PRODUCT TEAM II": 'read',
        "INSURANCE LEAD": 'read/write',
        "UNDERWRITING LEAD": 'read/write'
    },
    'Terminate Accounts': {
        "CSR III": 'read/write',
        ADJUDICATION: 'none',
        "ADJUDICATION II": 'none',
        MASTER: 'read/write',
        ADMIN: 'read/write',
        CSR: 'none',
        "CSR II": 'none',
        SALES: 'none',
        "SALES LEAD": 'read/write',
        ENGINEERING: 'none',
        "GSR LEAD": 'read/write',
        "INSURANCE LEAD": 'read/write',
        "UNDERWRITING II": 'read/write',
        "UNDERWRITING LEAD": 'read/write'
    },
    'Remove Predetermination': {
        MASTER: 'read/write',
        ADMIN: 'none',
        CSR: 'none',
        "CSR II": 'read/write',
        "CSR III": 'read/write',
        ADJUDICATION: 'read/write',
        "ADJUDICATION II": 'read/write',
        SALES: 'none',
        ENGINEERING: 'none'
    },
    'Reverse Dental Claims': {
        MASTER: 'read/write',
        ADMIN: 'none',
        CSR: 'none',
        "CSR II": 'read/write',
        "CSR III": 'read/write',
        ADJUDICATION: 'read/write',
        "ADJUDICATION II": 'read/write',
        SALES: 'none',
        ENGINEERING: 'none'
    },
    'Remove Pending EDI Transaction': {
        MASTER: 'read/write',
        ADMIN: 'none',
        CSR: 'none',
        "CSR II": 'read/write',
        "CSR III": 'read/write',
        ADJUDICATION: 'read/write',
        "ADJUDICATION II": 'read/write',
        SALES: 'none',
        ENGINEERING: 'none'
    },
    'Coverage History': {
        MASTER: 'read/write',
        ADMIN: 'none',
        CSR: 'none',
        "CSR II": 'none',
        "CSR III": 'read/write',
        ADJUDICATION: 'none',
        "ADJUDICATION II": 'read/write',
        SALES: 'none',
        "SALES II": 'none',
        "SALES LEAD": 'none',
        "PRODUCT TEAM": 'none',
        "PRODUCT TEAM II": 'read',
        GSR: 'read',
        "GSR II": 'read',
        "GSR III": 'read',
        "GSR LEAD": 'read',
        "INSURANCE LEAD": 'read',
        "UNDERWRITING II": 'read',
        "UNDERWRITING LEAD": 'read'
    },
    'Account Notes': {
        MASTER: 'read/write',
        ADMIN: 'read',
        CSR: 'read',
        "CSR II": 'read',
        "CSR III": 'read/write',
        ADJUDICATION: 'read',
        "ADJUDICATION II": 'read/write',
        SALES: 'read',
        "SALES II": 'read/write',
        "SALES LEAD": 'read',
        "PRODUCT TEAM": 'read',
        "PRODUCT TEAM II": 'read',
        GSR: 'read',
        "GSR II": 'read/write',
        "GSR III": 'read/write',
        "GSR LEAD": 'read/write',
        "INSURANCE LEAD": 'read/write',
        ACCOUNTING: 'read',
        "ACCOUNTING II": 'read/write',
        UNDERWRITING: 'read',
        "UNDERWRITING II": 'read/write',
        "UNDERWRITING LEAD": 'read/write'
    },
    'Change Request Status Change': {
        MASTER: 'read/write',
        ADMIN: 'none',
        CSR: 'read',
        "CSR II": 'read/write',
        "CSR III": 'read/write',
        ADJUDICATION: 'none',
        "ADJUDICATION II": 'none',
        SALES: 'none',
        "PRODUCT TEAM": 'none',
        "PRODUCT TEAM II": 'none',
        "INSURANCE LEAD": 'read/write'
    },
    'Change Request Assign Change': {
        MASTER: 'read/write',
        ADMIN: 'none',
        CSR: 'none',
        "CSR II": 'none',
        "CSR III": 'read/write',
        ADJUDICATION: 'none',
        "ADJUDICATION II": 'none',
        SALES: 'none',
        "PRODUCT TEAM": 'none',
        "PRODUCT TEAM II": 'none',
        "INSURANCE LEAD": 'read/write'
    },
    'Block Claims': {
        MASTER: 'read/write',
        ADMIN: 'none',
        CSR: 'none',
        "CSR II": 'none',
        "CSR III": 'none',
        ADJUDICATION: 'none',
        "ADJUDICATION II": 'none',
        SALES: 'none',
        "SALES II": 'none',
        "SALES LEAD": 'none',
        "PRODUCT TEAM": 'none',
        "PRODUCT TEAM II": 'none',
        GSR: 'none',
        "GSR II": 'none',
        "GSR III": 'none',
        "GSR LEAD": 'read/write',
        "INSURANCE LEAD": 'read/write',
        ACCOUNTING: 'none',
        "ACCOUNTING II": 'read/write',
        UNDERWRITING: 'none',
        "UNDERWRITING II": 'none',
        "UNDERWRITING LEAD": 'none'
    },
    'Assign Agent Benefits': {
        MASTER: 'read/write',
        ADMIN: 'none',
        CSR: 'none',
        "CSR II": 'none',
        "CSR III": 'none',
        ADJUDICATION: 'none',
        "ADJUDICATION II": 'none',
        SALES: 'none',
        "SALES II": 'none',
        "SALES LEAD": 'none',
        "PRODUCT TEAM": 'none',
        "PRODUCT TEAM II": 'none',
        GSR: 'none',
        "GSR II": 'none',
        "GSR III": 'none',
        "GSR LEAD": 'none',
        "INSURANCE LEAD": 'read/write',
        ACCOUNTING: 'none',
        "ACCOUNTING II": 'none',
        UNDERWRITING: 'none',
        "UNDERWRITING II": 'none',
        "UNDERWRITING LEAD": 'none'
    },
    'Ignore Assignee': {
        MASTER: 'read/write',
        ADMIN: 'none',
        CSR: 'none',
        "CSR II": 'none',
        "CSR III": 'none',
        ADJUDICATION: 'none',
        "ADJUDICATION II": 'none',
        SALES: 'none',
        "SALES II": 'none',
        "SALES LEAD": 'none',
        "PRODUCT TEAM": 'none',
        "PRODUCT TEAM II": 'none',
        GSR: 'none',
        "GSR II": 'none',
        "GSR III": 'none',
        "GSR LEAD": 'none',
        "INSURANCE LEAD": 'read/write',
        ACCOUNTING: 'none',
        "ACCOUNTING II": 'none',
        UNDERWRITING: 'none',
        "UNDERWRITING II": 'none',
        "UNDERWRITING LEAD": 'none'
    },
    'Electronic Submission Requests': {
        MASTER: 'read/write',
        ADMIN: 'none',
        CSR: 'read',
        "CSR II": 'read/write',
        "CSR III": 'read/write',
        ADJUDICATION: 'read/write',
        "ADJUDICATION II": 'read/write',
        SALES: 'none',
        "SALES II": 'none',
        "SALES LEAD": 'none',
        "PRODUCT TEAM": 'none',
        "PRODUCT TEAM II": 'read',
        GSR: 'none',
        "GSR II": 'none',
        "GSR III": 'read',
        "GSR LEAD": 'read',
        "INSURANCE LEAD": 'read/write',
        ACCOUNTING: 'none',
        "ACCOUNTING II": 'read',
        UNDERWRITING: 'none',
        "UNDERWRITING II": 'none',
        "UNDERWRITING LEAD": 'none'
    }
};

/**
 * @param permission
 * @param accessType
 * @returns {null|*|null}
 */
function permissionLevel(permission, accessType) {
    const data = permissions[permission];

    if (!data) {
        return 'none';
    }

    return data[accessType] || 'none';
}

export default permissionLevel;